import React from "react";
import AppTemplate from "../components/Privacypolicy";

const Privacypolicy: React.FC = () => {
  return (
    <AppTemplate>
      <>ダッシュボード</>;
    </AppTemplate>
  );
};

export default Privacypolicy;
